import React from "react";

//interfaces
import { IIconComponentProps } from "@/types/components/IconComponentProps";

function EarthGlobeIcon(props: IIconComponentProps<SVGSVGElement>) {

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" { ...props }>
      <path d="M17.0833 7.5H2.91667M17.0833 12.5H2.91667M13.3333 10C13.3333 14.1421 11.8409 17.5 10 17.5C8.15905 17.5 6.66667 14.1421 6.66667 10C6.66667 5.85786 8.15905 2.5 10 2.5C11.8409 2.5 13.3333 5.85786 13.3333 10ZM9.16667 2.5H10.8333C14.5152 2.5 17.5 5.48477 17.5 9.16667V10.8333C17.5 14.5152 14.5152 17.5 10.8333 17.5H9.16667C5.48477 17.5 2.5 14.5152 2.5 10.8333V9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default EarthGlobeIcon;
